import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AppComponent } from '../../app.component';
import { SharedService } from '../../services/shared.service';
import { Constants } from '../../constants';
import { mvnfbuAnimations } from '../../shared/animations';

@Component({
  selector: 'app-animation',
  templateUrl: './animation.component.html',
  styleUrl: './animation.component.scss',
  standalone: false,
  animations: mvnfbuAnimations
})
export class AnimationComponent implements OnInit, OnChanges, OnDestroy {

  animationStateOut = false;

  blobUrl = '';
  @Input()  imageUrl : string = "";
  @Input() animationName: string = "";

  public animationUrl: string = '';
  private appComponent: AppComponent;
  private animationEndId?: number;


constructor(private sharedService: SharedService, private injector: Injector) {
    this.blobUrl = sharedService.blobUrl;
    this.appComponent = this.injector.get(AppComponent);
  }

ngOnChanges(changes: SimpleChanges): void {
  console.log("change animation")
   this.resetAnimation();
    this.loadAnimation();
   
}

private resetAnimation():void{
      //Réinitialiser les classes CSS
      const animationElement = document.getElementById('animation');
      const imageElement = document.getElementById('image');
      
      if (animationElement && imageElement) {
        animationElement.classList.remove('fade-out');
        imageElement.classList.remove('fade-in');
      }
  }

ngOnInit():void {
  console.log("init animation")
  this.loadAnimation();
}

 ngOnDestroy(): void {
    if (this.animationEndId) {
      clearTimeout(this.animationEndId);
      this.animationEndId = undefined;
    }
  }

private loadAnimation(): void {
    const lang = this.appComponent.currentLanguage || 'fr';
    console.log(this.animationName);
    let imageName = Constants.Animations[this.animationName as keyof typeof Constants.Animations] || this.animationName;
    imageName = imageName +'-' + lang.toUpperCase() + Constants.Animations.Extension;
    
    if (this.animationEndId) {
      clearTimeout(this.animationEndId);
    }
    
    this.animationUrl =  this.sharedService.buildUrlBlob(imageName, 'Local-news/animation/');
    console.log("animation url: " + this.animationUrl);
    this.animationEndId = window.setTimeout(() => {
      const animationElement = document.getElementById('animation');
      const imageElement = document.getElementById('image');

      if (animationElement && imageElement) {
        animationElement.classList.add('fade-out');
        imageElement.classList.add('fade-in');
      }
    }, 8100);
  }
}
